import React, { forwardRef, useMemo } from 'react';
import classNames from 'classnames';

import { renderFormulas } from '@/services/FormulaUtils';

export type QuestionPanelProps = {
	title: string;
	questionHtml: string;
	imageUrls: string[];
	questionHasImage: boolean;
	visible: boolean;
	onImageClick: (src: string) => void;
};

const sanitizeQuestionHtml = (html: string): string => {
	return renderFormulas(
		html.replace(/<figure[\s\S]*?<\/figure>/gi, '').replace(/<img[^>]*>/gi, ''),
	);
};

const QuestionPanel = forwardRef<HTMLDivElement, QuestionPanelProps>(
	({ title, questionHtml, imageUrls, questionHasImage, visible, onImageClick }, ref) => {
		const firstImage = imageUrls[0] ?? '';
		const textHtml = useMemo(() => sanitizeQuestionHtml(questionHtml || ''), [questionHtml]);

		return (
			<div
				className="lane-chooser__question"
				style={{ visibility: visible ? 'visible' : 'hidden' }}
				ref={ref}
			>
				<div className="lane-chooser__question-split">
					{firstImage && (
						<div className="lane-chooser__question-left">
							<button
								className="wysiwyg-content lane-chooser__question-image-btn"
								onClick={() => onImageClick(firstImage)}
								aria-label="Open image preview"
								type="button"
							>
								<img src={firstImage} alt="Question" />
							</button>
						</div>
					)}
					<div
						className={classNames('lane-chooser__question-right', {
							'lane-chooser__question-right--no-image': !questionHasImage,
						})}
					>
						{title && <h1 className="lane-chooser__question-title">{title}</h1>}
						<div
							className="wysiwyg-content"
							dangerouslySetInnerHTML={{ __html: textHtml }}
						/>
					</div>
				</div>
			</div>
		);
	},
);

export default QuestionPanel;
